module.exports = __webpack_public_path__ + "img/times-circle-light.d6ef0535.svg";